import { DatePipe } from '@angular/common';
import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  AccountingMethod,
  ActionType,
  AnnualReportUploadType,
  ChartOfAccountExpenseGroupTypeName,
  ChartOfAccountIncomeGroupTypeName,
  ConfirmationType,
  FontSize,
  GroupNames,
  MaxLength,
  Modules,
  NotificationDetails,
  NotificationHeader,
  NotificationTextMessage,
  RoutingPath,
} from '@app/core/Enum';
import {
  AnnualReportModel,
  FileUploadRequestModel,
  FileUploadResponseModel,
  GlobalComponent,
  TshqRequestOptions,
} from '@app/core/Models';
import { CommonService } from '@app/core/Services';
import {
  FileUpload,
  GetSaasURL,
  GetByAccountPeriod,
  SaveAnnualReport,
  GetAccountingMethod,
  GetAnnualReportResponse,
  GetListSavedFile,
  GetSavedAnnualReportResponse,
  DownloadSavedAnnualReport,
  DownloadAnnualReport,
  MenuState,
  GetContactList,
  GetFundOpeningBalanceBasedOnAPId,
  GetAccountProductionTrialBalance,
  GetJournalAccounts,
  AccountState,
} from '@app/core/Store';
import {
  AddClosePopupComponent,
  ConfirmationBoxComponent,
} from '@app/modules/common';
import { Select, Store } from '@ngxs/store';
import { Guid } from 'guid-typescript';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subscription, forkJoin } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Location } from '@angular/common';

import {
  EditorHistoryService,
  EditorService,
  PrintService,
  SelectionService,
  SfdtExportService,
  ToolbarService,
} from '@syncfusion/ej2-angular-documenteditor';
import { HttpClient } from '@angular/common/http';
import { AnnualReportPopupComponent } from './annual-report-popup/annual-report-popup.component';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { PdfPreviewComponent } from './pdf-preview/pdf-preview.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-annual-report',
  templateUrl: './annual-report.component.html',
  styleUrls: ['./annual-report.component.scss'],
  providers: [
    ToolbarService,
    PrintService,
    SelectionService,
    EditorService,
    EditorHistoryService,
    SfdtExportService,
  ],
})
export class AnnualReportComponent implements OnInit {
  @ViewChild('iframe') iframe: ElementRef;
  annualForm: FormGroup;

  src = '';
  annualReportContent = '';
  periodicDateList: any;
  accountingId: any;
  accountingPeriod: Guid;
  provideTrusteeFileName: string;
  examinerReportFileName: string;
  signatureFileName: string;
  moreActionCount = 4;
  selectedRowIndex = -1;
  contactList:any=[]
  dropdownSettings: IDropdownSettings = {};
  actions: any = [];

  moduleId = Modules.AnnualAccounts;

  isProvideTrusteePDFSelected = false;
  isExaminerReportPDFSelected = false;
  isSignatureSelected = false;
  showDocument = false;
  isLocked = false;
  noDataFound = false;

  url: any[] = [];
  showPath: any[] = [];
  fileList: any[] = [];

  id = Guid.EMPTY as unknown as Guid;
  annualData: AnnualReportModel;

  acceptedFileTypes = ['.pdf'];
  acceptedSignatureFileTypes = ['.jpg', '.jpeg', '.png'];

  subscriptionRouting: Subscription;
  fileUploadResponse: FileUploadResponseModel;
  fileUploadRequest: FileUploadRequestModel;
  uploadType: AnnualReportUploadType;

  provideNamefileUploadResponse: FileUploadResponseModel;
  examinerNamefileUploadResponse: FileUploadResponseModel;
  signaturefileUploadResponse: FileUploadResponseModel;

  fileURl: string;
  isIframeHidden = true;

  srcDocContent: string;

  maxLength = MaxLength;
  fontSizeList = FontSize;
  fontFamilies = [
    'Arial',
    'sans-serif',
    'Times New Roman',
    'Verdana',
    'Courier New',
    'Cursive',
  ];
  annualReportListSavedFiles: any[] = [];

  displayedColumns = ['srno', 'period', 'saveDate', 'saveTime', 'action'];
  dataSource = new MatTableDataSource<any>();
  accountingMethodId: any;
  accountingMethod = AccountingMethod;

  public culture: string = 'en-US';
  generatedReport: any;

  @Select(MenuState.getSelectedMenuPermission)
  isViewPermission$: Observable<any>;
  commonNotificationText = NotificationTextMessage;
  regenerateAnnualReportId:any;
  foundPeriod : any;
  constructor(
    private store: Store,
    public commonService: CommonService,
    private spinner: NgxSpinnerService,
    private globalComponent: GlobalComponent,
    public dialog: MatDialog,
    private renderer: Renderer2,
    public datepipe: DatePipe,
    public location: Location,
    private http: HttpClient,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.accountingMethodId = this.globalComponent.getAccountingMethod();

    this.dropdownSettings = {
      singleSelection: false,  
      idField: 'id',           
      textField: 'name',      
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
    
    this.setForm();
    this.setPeriodDate();
  }

  onCreate(): void {
    this.store
      .dispatch(new GetAnnualReportResponse(this.accountingId))
      .pipe()
      .subscribe(
        (response: any) => {
          this.openAnnualReportPopup(response?.annualReport?.htmlContent, false,null,true);
        },
        (error: any) => {
          console.error('Failed:', error);
        }
      );
  }

  viewSavedReport(element): void {
    this.spinner.show();
    this.store
      .dispatch(new GetSavedAnnualReportResponse(this.accountingId, element.id))
      .pipe()
      .subscribe(
        (response: any) => {
          this.spinner.hide();
          this.openAnnualReportPopup(response?.annualReport?.getContent, true, element.id,false, element);
        },
        (error: any) => {
          this.spinner.hide();
          console.error('Failed:', error);
        }
      );
  }

  openAnnualReportPopup(
    response: any,
    isEdit: boolean,
    saveAnnualReportResponseId?: any,
    isSave?:boolean,
    element?: any
  ): void {
    let selectedPeriodDetail = this.periodicDateList.filter(
      (x) => x.id === this.accountingPeriod
    );
    let selectedDateRange = '';
    if (selectedPeriodDetail.length > 0) {
      selectedDateRange = selectedPeriodDetail[0].name.replace(/\s/g, '');
    }
    // this.dialog
    //   .open(AnnualReportPopupComponent, {
    //     panelClass: 'annual-report-dialog',
    //     width: '100vw',
    //     height: '100vh',
    //     maxWidth: '100vw',
    //     maxHeight: '100vh',
    //     data: {
    //       res: response,
    //       selectedDateRange: selectedDateRange,
    //       accountingPeriod: this.accountingPeriod,
    //       isEdit: isEdit,
    //       saveAnnualReportResponseId: isEdit
    //         ? saveAnnualReportResponseId
    //         : (Guid.EMPTY as unknown as Guid),
    //     },
    //     disableClose: true,
    //   })
    //   .afterClosed()
    //   .subscribe((result) => {
    //     this.getListSavedFiles();
    //   });

    this.dialog
          .open(PdfPreviewComponent,  {
              // panelClass: 'annual-report-dialog',
               //width: '95vw',
              maxWidth: '80vw',
            data : {
            res: response,
            accountingPeriod: this.accountingPeriod,
            saveAnnualReportResponseId: isEdit
                     ? saveAnnualReportResponseId
                    : (Guid.EMPTY as unknown as Guid),
            isSave:isSave,
            accountingId:this.accountingId,
            regenerateAnnualReportId : this.regenerateAnnualReportId,
            isShowSubmit: element?.isShowSubmit,   
            charityType: element?.charityType
          },
          disableClose: true,})
          .afterClosed()
          .subscribe((result) => {
             this.getListSavedFiles();
          });
  }
  setForm(): void {
    this.annualForm = new FormGroup({
      name: new FormControl([], [Validators.required]),
      designation: new FormControl('', [Validators.required]),
      date: new FormControl(new Date(), [Validators.required]),
      color: new FormControl('#FFFFFF'),
      showPriorYearValue: new FormControl(true),
      //fontFamily : new FormControl({ value: "Arial", disabled: true }),
      fontFamily : new FormControl( "Arial"),
    });
  }

  onSignatureDeletePDF(): void {
    this.isSignatureSelected = false;
    this.signatureFileName = '';
    this.signaturefileUploadResponse = new FileUploadResponseModel();
  }

  onCloseClick(): void {
    this.dialog.open(AddClosePopupComponent, {});
  }

  onAccountPeriodChange(): void {
    this.spinner.show();
    const selectedPeriod = this.periodicDateList.find(
      (p) => p.id === this.accountingPeriod
    );
    if (selectedPeriod) {
      localStorage.setItem('defaultFinancialPeriod', selectedPeriod.name.trim());
    }

    const selectedPeriodDate = this.periodicDateList.find(p => p.id === this.accountingPeriod);
    if (selectedPeriodDate) {
      const startDate = this.datepipe.transform(selectedPeriodDate.fromDate, 'yyyy-MM-dd')!;
      const endDate = this.datepipe.transform(selectedPeriodDate.toDate, 'yyyy-MM-dd')!;
      this.getContactList(startDate, endDate); 
    }

    this.getByAccountPeriod();
    this.getListSavedFiles();
  }

  setPeriodDate(): void {
    this.periodicDateList = this.globalComponent.getFinancialPeriod();

    const defaultPeriodName = localStorage.getItem('defaultFinancialPeriod');
    let selectedPeriod: any;

    if (defaultPeriodName) {
      this.foundPeriod = this.periodicDateList.find(
        (p) => p.name.trim() === defaultPeriodName.trim()
      );
      selectedPeriod = this.foundPeriod
        ? this.foundPeriod
        : this.periodicDateList.length > 0
        ? this.periodicDateList[0]
        : null;
    } else {
      selectedPeriod = this.periodicDateList.length > 0 ? this.periodicDateList[0] : null;
    }

    if (selectedPeriod) {
      this.accountingPeriod = selectedPeriod.id;
      const startDate = this.datepipe.transform(selectedPeriod.fromDate, 'yyyy-MM-dd')!;
      const endDate = this.datepipe.transform(selectedPeriod.toDate, 'yyyy-MM-dd')!;
      this.getContactList(startDate, endDate);
    }else{
      this.spinner.hide();
      return;
    }

    this.getByAccountPeriod();
    this.getListSavedFiles();
  }

  getSaasURL(url: any, type: any): void {
    const data = {
      fileUrl: url,
    };

    this.store.dispatch(new GetSaasURL(data)).subscribe((res) => {
      if (type === AnnualReportUploadType.signature) {
        this.signatureFileName = res.common.generateSaasURLModel;
      }
    });
  }

  onSignatureSelection(event: any): void {
    if (!event.target.files || !event.target.files.length) {
      return;
    }

    if (
      event.target.files[0].type === 'image/jpeg' ||
      event.target.files[0].type === 'image/png' ||
      event.target.files[0].type === 'image/jpg'
    ) {
      this.isSignatureSelected = true;
      this.signatureFileName = event.target.files[0].name;
      this.saveFile(event.target.files[0], AnnualReportUploadType.signature);

      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        this.url.push(reader.result);
      };
    } else {
      this.commonService.onFailure(
        NotificationTextMessage.fileExtensionValidatonForImage
      );
    }
  }
  
  saveFile(file: File, type: Number): void {
    this.fileList = [];
    this.fileList.push(file);

    this.fileUploadRequest = {
      file: this.fileList,
      attachmentType: 1,
    };

    this.store
      .dispatch(new FileUpload(this.fileUploadRequest))
      .pipe(
        tap((data) => {
          if (type === AnnualReportUploadType.signature) {
            this.signaturefileUploadResponse =
              data.common.fileUploadRequestModel[0];
          }

          this.getSaasURL(data.common.fileUploadRequestModel[0].fileUrl, type);
        })
      )
      .subscribe();
  }

  get accept(): string {
    return this.acceptedFileTypes?.join(', ') ?? '';
  }

  get acceptSignature(): string {
    return this.acceptedSignatureFileTypes?.join(', ') ?? '';
  }

  dataSubmit() {
    this.spinner.show();
    try {
      this.annualData = {
        id: this.id,
        accountingPeriodId: this.accountingPeriod,
        name: this.annualForm.controls.name.value.map(item => item?.name),
        designation: this.annualForm.controls.designation.value,
        showPriorYearValue: this.annualForm.controls.showPriorYearValue.value,
        date: this.datepipe
          .transform(this.annualForm.controls.date.value, 'yyyy-MM-dd')
          ?.toString()!,
        trusteeReportFile:
          this.provideNamefileUploadResponse === undefined
            ? null
            : this.provideNamefileUploadResponse.fileUrl,
        examinerReportFile:
          this.examinerNamefileUploadResponse === undefined
            ? null
            : this.examinerNamefileUploadResponse.fileUrl,
        signature:
          this.signaturefileUploadResponse === undefined
            ? null
            : this.signaturefileUploadResponse.fileUrl,
        color: this.annualForm.controls.color.value,
        fontFamily: this.annualForm.controls.fontFamily.value,
      };
    } catch (error) {
      this.spinner.hide();

      this.commonService.onFailure(NotificationTextMessage.errorMessage);
      return false;
    }
    return true;
  }

  onSave(): void {
    if (!this.periodicDateList?.length) {
      this.commonService.onFailure(NotificationTextMessage.noUnlockedPeriodAvailable);
      return;
    }
    if (this.annualForm.invalid) {
       this.commonService.onFailure(NotificationTextMessage.validationMessage);
      this.commonService.addValidation(this.annualForm, this.renderer);
    } else {
      if (this.dataSubmit()) {
        if (this.annualData) {
          this.store
            .dispatch(new SaveAnnualReport(this.annualData))
            .pipe()
            .subscribe(
              (res) => {
                if (res !== undefined) {
                  this.commonService.onSucess(
                    NotificationTextMessage.successMessage
                  );
                  this.getByAccountPeriod();
                } else {
                  this.commonService.onFailure(
                    NotificationTextMessage.errorMessage
                  );
                }
              },
              (err) => {
                this.commonService.onFailure(err.error.Message);
              }
            );
        }
      }
    }
  }

  getListSavedFiles(): void {
    this.store
      .dispatch(new GetListSavedFile(this.accountingId))
      .subscribe((res) => {
        if (res.annualReport.annualReportFileList.length > 0) {
          this.annualReportListSavedFiles = [];
          let selectedPeriodDetail = this.periodicDateList.filter(
            (x) => x.id === this.accountingPeriod
          );
          let selectedDateRange = '';
          if (selectedPeriodDetail.length > 0) {
            selectedDateRange = selectedPeriodDetail[0].name.replace(/\s/g, '');
          }
          res.annualReport.annualReportFileList.forEach((element, i) => {
            const dataDisplay = {
              id: element.id,
              srno: i + 1,
              period: selectedDateRange,
              saveDate: element.savedDate,
              saveTime: element.savedTime,
              isShowSubmit:element.isShowSubmit,
              charityType:element.charityType
            };
            this.annualReportListSavedFiles.push(dataDisplay);
            this.noDataFound =
              this.annualReportListSavedFiles.length > 0 ? false : true;
          });
          this.dataSource.data = this.annualReportListSavedFiles;
        } else {
          this.dataSource.data = [];
          this.annualReportListSavedFiles = [];
          this.noDataFound = true;
        }
      });
  }

  getByAccountPeriod() {
    this.accountingId = this.accountingPeriod;

    this.store
      .dispatch(new GetByAccountPeriod(this.accountingId))
      .subscribe((res) => {
        if (res) {
          this.annualData = res.annualReport.annualReportData;
          if (this.annualData !== null) {
            this.id = this.annualData.id;
           
            
               this.actions = [
                {
                  name: 'Submit To Companies House',
                  actionType: ActionType.Redirect,
                  icon: 'content_paste_go',
                },
                {
                  name: 'View / Edit',
                  actionType: ActionType.View,
                  icon: 'visibility',
                },
                {
                  name: 'Download Pdf',
                  actionType: ActionType.Export,
                  icon: 'picture_as_pdf',
                },
                {
                  name: 'Download Word',
                  actionType: ActionType.ExportWord,
                  icon: 'description',
                },
                {
                  name: 'Delete',
                  actionType: ActionType.Delete,
                  icon: 'delete_outline',
                },
              ];
            this.signatureFileName = '';
            this.signaturefileUploadResponse = new FileUploadResponseModel();
            this.isSignatureSelected = false;

            if (
              this.annualData.signature !== null &&
              this.annualData.signature !== undefined
            ) {
              this.isSignatureSelected = true;
              this.signaturefileUploadResponse.fileUrl =
                this.annualData.signature;
              this.signatureFileName = this.annualData.signature.replace(
                /^.*[\\\/]/,
                ''
              );

              this.getSaasURL(
                this.signaturefileUploadResponse.fileUrl,
                AnnualReportUploadType.signature
              );
            }

            this.accountingPeriod = this.annualData.accountingPeriodId;

            let selectedTrustees: any[] = [];

            if (this.annualData.name && typeof this.annualData.name === 'string') {
              const names = this.annualData.name.split(',').map(n => n.trim());

              selectedTrustees = this.contactList.filter(c =>
                names.includes(c.name)
              );
            }
            
            this.annualForm.patchValue({
              date: this.annualData.date,
              name: selectedTrustees,
              designation: this.annualData.designation,
              //color: this.annualData.color,
              showPriorYearValue: this.annualData.showPriorYearValue,
              fontFamily:this.annualData.fontFamily,
            });
          } else {
            this.signatureFileName = '';
            this.isSignatureSelected = false;
            this.id = Guid.EMPTY as unknown as Guid;
            this.annualForm.patchValue({
              date: new Date(),
              name: '',
              designation: '',
              color: '#FFFFFF',
            });
          }
        }
        this.src = '';
      });
  }

  onCancel(): void {
    this.accountingId = Guid.EMPTY as unknown as Guid;
    this.ngOnInit();
  }

  generateReport(): void {
    if (!this.periodicDateList?.length) {
      this.commonService.onFailure(NotificationTextMessage.noUnlockedPeriodAvailable);
      return;
    }
    if (this.annualForm.invalid) {
      this.commonService.addValidation(this.annualForm, this.renderer);
    } else {
      this.accountingId = this.accountingPeriod;
      this.checkFundExplainBeforePreview();
    }
  }

  checkFundExplainBeforePreview(): void {
    this.spinner.show();
    forkJoin([
      this.store.dispatch(new GetAccountProductionTrialBalance(this.accountingId)),
      this.store.dispatch(new GetJournalAccounts()),
      this.store.dispatch(new GetFundOpeningBalanceBasedOnAPId(this.accountingId)),
    ]).subscribe(
      ([tbRes, accountsRes, fundExplainRes]) => {
        this.spinner.hide();
        const tbData = tbRes.accountProduction.openingBalanceData;
        const accountList: any[] = this.commonService.addGroupNameToListModels(
          this.store.selectSnapshot(AccountState.getJournalAccounts)
        );
        const fundExplainData = fundExplainRes.openingBalance.openingBalanceFundExplainData;

        const tbEntries = tbData?.openingBalanceData || tbData || [];
        if (!Array.isArray(tbEntries) || tbEntries.length === 0) {
          this.proceedWithPreview();
          return;
        }

        const hasFundsInTB = tbEntries.some(
          (entry: any) => accountList?.find((acc: any) => acc.id === entry.accountId)?.groupId === GroupNames.Funds
        );

        if (!hasFundsInTB) {
          this.proceedWithPreview();
          return;
        }

        if (this.hasFundExplainDifference(tbEntries, accountList, fundExplainData)) {
          this.showFundExplainConfirmation();
        } else {
          this.proceedWithPreview();
        }
      },
      () => {
        this.spinner.hide();
        this.proceedWithPreview();
      }
    );
  }

  hasFundExplainDifference(tbEntries: any[], accountList: any[], fundExplainData: any[]): boolean {
    // Calculate TB totals (same logic as Fund Explain component)
    let tbIncome = 0;
    let tbExpense = 0;
    let tbGainLoss = 0;

    tbEntries.forEach((x: any) => {
      const account = accountList?.find((acc: any) => acc.id === x.accountId);
      if (!account) return;

      const totalCredit = +(x.endowmentCredit || 0) + +(x.restrictedCredit || 0) + +(x.unrestrictedCredit || 0);
      const totalDebit = +(x.endowmentDebit || 0) + +(x.restrictedDebit || 0) + +(x.unrestrictedDebit || 0);

      if (account.groupId === GroupNames.Income) {
        if (
          account.typeId === ChartOfAccountIncomeGroupTypeName.DonationsAndLegacies ||
          account.typeId === ChartOfAccountIncomeGroupTypeName.CharitableActivities ||
          account.typeId === ChartOfAccountIncomeGroupTypeName.OtherTradingActivities ||
          account.typeId === ChartOfAccountIncomeGroupTypeName.Investments ||
          account.typeId === ChartOfAccountIncomeGroupTypeName.SeparateMaterialItemofIncome ||
          account.typeId === ChartOfAccountIncomeGroupTypeName.Other
        ) {
          tbIncome += (totalCredit - totalDebit);
        } else if (
          account.typeId === ChartOfAccountIncomeGroupTypeName.GainsLossesonRevaluationofFixedAssets ||
          account.typeId === ChartOfAccountIncomeGroupTypeName.OtherGainsLosses
        ) {
          tbGainLoss += (totalCredit - totalDebit);
        }
      } else if (account.groupId === GroupNames.Expense) {
        if (
          account.typeId === ChartOfAccountExpenseGroupTypeName.RaisingFunds ||
          account.typeId === ChartOfAccountExpenseGroupTypeName.CharitableActivities ||
          account.typeId === ChartOfAccountExpenseGroupTypeName.SupportCosts ||
          account.typeId === ChartOfAccountExpenseGroupTypeName.FinanceCosts ||
          account.typeId === ChartOfAccountExpenseGroupTypeName.GovernanceCosts ||
          account.typeId === ChartOfAccountExpenseGroupTypeName.Other
        ) {
          tbExpense += (totalDebit - totalCredit);
        } else if (
          account.typeId === ChartOfAccountExpenseGroupTypeName.GainsLossesonRevaluationofFixedAssets ||
          account.typeId === ChartOfAccountExpenseGroupTypeName.OtherGainsLosses
        ) {
          tbGainLoss -= (totalDebit - totalCredit);
        }
      }
    });

    tbIncome = +tbIncome.toFixed(2);
    tbExpense = +tbExpense.toFixed(2);
    tbGainLoss = +tbGainLoss.toFixed(2);

    // If TB has no income/expense/gainloss accounts, nothing to assign to funds
    if (tbIncome === 0 && tbExpense === 0 && tbGainLoss === 0) {
      return false;
    }

    // Calculate fund explain totals
    let explainIncome = 0;
    let explainExpense = 0;
    let explainGainLoss = 0;

    if (fundExplainData && fundExplainData.length > 0) {
      fundExplainData.forEach((item: any) => {
        explainIncome += +(item.income || 0);
        explainExpense += +(item.expenditure || 0);
        explainGainLoss += +(item.netGainLoss || 0);
      });
    }

    explainIncome = +explainIncome.toFixed(2);
    explainExpense = +explainExpense.toFixed(2);
    explainGainLoss = +explainGainLoss.toFixed(2);

    // Check for differences in income/expense/gainloss only
    return (
      tbIncome !== explainIncome ||
      tbExpense !== explainExpense ||
      tbGainLoss !== explainGainLoss
    );
  }

  showFundExplainConfirmation(): void {
    this.dialog
      .open(ConfirmationBoxComponent, {
        data: {
          type: ConfirmationType.FundExplainCheck,
          headerText: NotificationHeader.confirmation,
          detailText: NotificationDetails.fundExplainCheckDetailText,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.proceedWithPreview();
        }
      });
  }

  proceedWithPreview(): void {
    this.showDocument = true;
    this.spinner.show();
    this.onCreate();
  }

  downloaReport(format: string = 'Docx'): void {
    if (this.annualForm.invalid) {
      this.commonService.addValidation(this.annualForm, this.renderer);
    } else {
      this.accountingId = this.accountingPeriod;

      this.spinner.show();
      this.store
        .dispatch(
          new DownloadAnnualReport({
            accountingPeriodId: this.accountingPeriod,
            format: format,
          })
        )
        .subscribe();
    }
  }

  onDelete(element): void {
    let ids: any[] = [];
    ids.push(element.id);

    if (ids.length > 0) {
      this.dialog
        .open(ConfirmationBoxComponent, {
          data: {
            ids: ids,
            type: ConfirmationType.Delete,
            moduleId: Modules.AnnualAccounts,
            totalNumberOfRecordSelected: ids.length,
            headerText: NotificationHeader.deleteConfirmation,
            detailText: NotificationDetails.deleteAllDetailText,
            accountingPeriod: this.accountingPeriod,
          },
        })
        .afterClosed()
        .subscribe((result) => {
          if (result) {
            this.getListSavedFiles();
          }
        });
    }
  }

  onButtonClick(element: any, actionType: ActionType): void {
    this.regenerateAnnualReportId = element.id;
    if (
      actionType === ActionType.Delete ||
      actionType === ActionType.Export ||
      actionType === ActionType.ExportWord || 
      actionType === ActionType.View || 
      actionType === ActionType.Redirect
    ) {
      switch (actionType) {
        case ActionType.Delete:
          this.onDelete(element);
          break;
        case ActionType.View:
          this.viewSavedReport(element);
          break;
        case ActionType.Export:
          this.downloadSavedFile(element, "pdf");
          break;
        case ActionType.ExportWord:
          this.downloadSavedFile(element, "word");
          break;
        case ActionType.Redirect:
          this.redirectToSubmit(element.id);
          break;
      }
    } else {
      this.commonService.onFailure(NotificationTextMessage.dataInLockedPeriod);
    }
  }

  redirectToSubmit(id: any): void{
    this.router.navigate([RoutingPath.submitCompaniesHouse, { id: id,periodId:this.accountingPeriod }]);
  }

  allowCloseOnClickOut(): void {
    this.selectedRowIndex = -1;
  }

  onToggleMatMenu(i): void {
    this.selectedRowIndex = i;
  }

  downloadSavedFile(element, docType : string): void {
    this.spinner.show();
    this.store
      .dispatch(
        new DownloadSavedAnnualReport(this.accountingPeriod, element.id, docType)
      )
      .subscribe();
  }

  // onPrint(): void {
  //   (this.container.documentEditor as DocumentEditorComponent).print();
  // }

  // onDownloadClick(format: string = 'Docx'): void {
  //   this.container.documentEditor.save(
  //     this.container.documentEditor.documentName === ''
  //       ? 'sample'
  //       : this.container.documentEditor.documentName,
  //     format as FormatType
  //   );
  // }
  
  getContactList(startDate: string, endDate: string): void {

    const obj = {
      contacttype: 2,
      startDate: startDate,
      endDate: endDate
    }

    this.store
      .dispatch(new GetContactList(obj))
      .subscribe((res) => {
        if (res?.annualReport?.contactList?.contacts?.length > 0) {
          this.contactList = res.annualReport.contactList?.contacts;
        } else {
          this.contactList = [];
        
        }
        console.log(this.contactList,'con')
      });
  }
  displayAction(isShowSubmit:boolean,action:number):boolean{
    if(action === ActionType.Redirect){
      if(isShowSubmit){
       return true;
      }else{
      return false;
      }
    }else{
    return true;
    }
  }

  onItemSelect(item: any) {}

  onItemDeSelect(item: any) {}

  onSelectAll(items: any) {}

}